"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/FocusTrapZone/index"), exports);
//# sourceMappingURL=FocusTrapZone.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/FocusTrapZone.js
// module id = ../node_modules/office-ui-fabric-react/lib/FocusTrapZone.js
// module chunks = 1